import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@ciam/library';
import { Observable, catchError, throwError, timeout } from 'rxjs';
import { APIResponse, PinRequest } from './APIResponse';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MfaPinService {

  constructor(private configService: ConfigurationService, private http: HttpClient) {}

  requestPin(otpData: PinRequest): Observable<APIResponse> {
    const url = this.configService.select<string>('endpoints.mfaPin.url');
    return this.http.post<APIResponse>(url, otpData, { withCredentials: true })
      .pipe(take(1), timeout(Number(this.configService.select<number>('endpoints.mfaPin.timeout'))),
        catchError(error => throwError(error))
      );
  }

  verifyPin(otpData: PinRequest): Observable<APIResponse> {
    const url = this.configService.select<string>('endpoints.validateMfaPin.url');
    return this.http.post<APIResponse>(url, otpData, { withCredentials: true })
      .pipe(take(1), timeout(Number(this.configService.select<number>('endpoints.validateMfaPin.timeout'))),
        catchError(error => throwError(error))
      );
  }
}

